import { ILineChartZoomManager, ZoomRange } from '@/shared/Charting/LineChart/lineChart.types.ts'
import EventEmitter from '@/utils/events.ts'
import debounce from '@/utils/debounce/debounce.ts'

const lineChartZoomManager = (): ILineChartZoomManager => ({
  mode$: new EventEmitter<ILineChartZoomManager['mode']>(),
  changes$: new EventEmitter<ZoomRange>(),
  mode: 'auto',

  xMin: Date.now() - 1000 * 60,
  xMax: Date.now(),
  yMax: 10,
  yMin: -10,

  _publishZoomChanges: debounce((data: ZoomRange, emitter: EventEmitter<ZoomRange>) => {
    emitter.next(data)
  }, 400),

  setZoom(range, producer) {
    if (producer === 'data-plugin' && this.mode === 'manual') {
      return
    }

    if (producer !== 'data-plugin' && this.mode !== 'manual') {
      this.mode = 'manual'
      this.mode$.next('manual')
    }

    if ('xMax' in range) this.xMax = range.xMax
    if ('xMin' in range) this.xMin = range.xMin
    if ('yMax' in range) this.yMax = range.yMax
    if ('yMin' in range) this.yMin = range.yMin

    this._publishZoomChanges(
      {
        xMin: this.xMin,
        xMax: this.xMax,
        yMax: this.yMax,
        yMin: this.yMin,
      },
      // @ts-ignore
      this.changes$
    )
  },
  switchMode(mode: ILineChartZoomManager['mode']) {
    this.mode = mode
    this.mode$.next(mode)
  },
})

export default lineChartZoomManager
